import { useEffect, useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import {
  getAlldealforAdmin,
  getDealById,
  getTaskTemplate,
  unassignLockboxesByDealId,
  updateItem,
  uploadImagesToFirebase,
} from "../../utils/firebasefunctions";
import { expandStageItems } from "../../utils/taskSections";
import { useStateValue } from "../../context/StateProvider";
import {
  emailAgentOnFileComplete,
  formatDate,
  formatNumberShort,
  newmessagesuccess,
  notifyAccountantsOnApproval,
  notifyAgentOnFileComplete,
} from "../../utils/helper";
import BreadCrumbs from "../reuseable/breadcrumbs";
import PageHeader from "../PageHeader";
import AddNewDeal from "../home/add-deal";
import { deleteObject, ref } from "firebase/storage";
import { doc, getDoc } from "firebase/firestore";
import { actionType } from "../../context/reducer";
import { firestored, storage } from "../../firebase/firebaseConfig";
import { toast } from "react-toastify";
import DeleteDeal from "../deals/delete-deal";
import DealStagePopup from "../DealStagePopup";
import DealDriveAttachment from "../deals-board/deal-drive-attachment";
import DocumentsTab from "../documents/DocumentsTab";
import { isDriveBrokerEnabled } from "../../utils/featureFlags";
import DealLocation from "./deal-location";
import PropertyImage from "./property-image";
import ComissionBreakDown from "./comission-breakdown";
import PeopleInvolve from "./people-involved";
import ClientInform from "./client-inform";
import Task from "../deals-board/task";
import Chat from "../deals-board/chat";
import StickyNote from "../deals-board/sticky-note";
import ListingDetail from "./listing-details";
import DealOpenHousesTab from "./deal-open-houses-tab";
import EmailCenterTab from "./EmailCenterTab";
import ClientPortalPanel from "./ClientPortalPanel";

function MainDetail() {
  const [{ employees, user, steps, deals, users }, dispatch] = useStateValue();
  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const isPage = searchParams.get("page");
  const [deal, setDeal] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const [isDelete, setIsDelete] = useState(false);
  const [dealstagepopup, setdealstagepopup] = useState(false);
  const taskId = searchParams.get("taskId");
  const type = searchParams.get("type");
  const [tasks, setTasks] = useState({});
  const [activeTab, setActiveTab] = useState(
    taskId ? "task" : type === "chat" ? "chat" : type === "emails" ? "emails" : "overview",
  );

  const columnIds = [
    "Prospect",
    "On Hold",
    "CMAs",
    "Listing Appointment",
    "Pre-Market",
    "Coming Soon",
    "Active",
    "Under Contract",
    "Pending",
    "Closed",
    "Cancelled",
    "Expired",
  ];

  const tabs =
    user.role == "Accountant"
      ? ["overview", "chat"]
      : ["overview", "documents", "task", "openHouses", "emails", "chat"];

  const [editdata, seteditdata] = useState({});

  const navigate = useNavigate();
  const fetchDeal = async () => {
    if (!id) return;
    try {
      const dealData = await getDealById(id);
      setDeal(dealData);
    } catch (err) {
      console.error("Failed to load deal:", err);
      const missing = (err?.message || "").toLowerCase().includes("not found");
      if (missing) {
        try {
          const cleared = await unassignLockboxesByDealId(id);
          if (cleared > 0) {
            toast.info(
              `That deal was deleted. Unassigned ${cleared} lockbox${cleared === 1 ? "" : "es"}.`,
            );
          } else {
            toast.error("That deal no longer exists.");
          }
        } catch (cleanupErr) {
          console.error("Lockbox cleanup failed:", cleanupErr);
          toast.error("That deal no longer exists.");
        }
      } else {
        toast.error("Could not load that deal.");
      }
      navigate(-1);
    }
  };

  const getAgent = (data) => {
    const agent = employees.find((x) => x.id === data.createdby);
    if (!agent) return ""; // agar agent na mile

    return `${agent.firstname} ${agent.lastname}`;
  };

  const formatCurrency = (value, currency = "USD") => {
    if (value === null || value === undefined || isNaN(value)) return "$0.00";

    return Number(value).toLocaleString("en-US", {
      style: "currency",
      currency,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  useEffect(() => {
    fetchDeal();
  }, [id]);

  const handleDeal = () => {
    getalldeal();
    fetchDeal();
  };

  async function getalldeal() {
    await getAlldealforAdmin("deals")
      .then(async (response) => {
        dispatch({
          type: actionType.STORE_DEALS,
          deals: response,
        });
      })
      .catch((err) => {
        alert(err);
      });
  }

  const handleOnEdit = (data) => {
    seteditdata(data);
    setIsOpen(true);
  };

  const handleDelete = (data) => {
    seteditdata(data);
    setIsDelete(true);
  };

  const updatedealstage = async (status) => {
    try {
      let newdata = {
        dealStage: status,
      };
      let result = await updateItem("deals", id, newdata);

      if (result === "success") {
        const updatedDeals = deals.map((item) =>
          item.createdat === id ? { ...item, ...newdata } : item,
        );
        console.log(updatedDeals);
        fetchDeal();
        setdealstagepopup(false);
      } else {
        toast.error(result || "Failed to update deal");
      }
    } catch (err) {
      toast.error(err.message);
    } finally {
    }
  };
  const updatedeal = async (data, bool, id) => {
    let finalImageUrls = [];
    const incomingFiles = data.step1.propertyphotofiles;

    // 🔥 1. Old data fetch karo (taake old images delete kiye jaa saken)
    const oldDoc = await getDoc(doc(firestored, "deals", id.toString()));
    const oldData = oldDoc.exists() ? oldDoc.data() : null;
    const oldImages = oldData?.propertyphoto || [];

    const selectedStage = data.step1.dealStage;

    const stageIndex = columnIds.indexOf(selectedStage);
    const allowedStages = columnIds.slice(0, stageIndex + 1);

    // 🔥 old tasks & tracker
    let existingTasks = oldData?.tasks || [];
    let existingTracker = oldData?.taskStatusTracker || {};
    let newTasks = [];
    let updatedTracker = { ...existingTracker };

    const _agentId = data.step3?.agentid;
    const _agentUser = (users || []).find((u) => u.id === _agentId);
    const _coordId = _agentUser?.listingCoordinatorId;
    const _coord = _coordId ? (users || []).find((u) => u.id === _coordId) : null;
    const coordinator = _coord
      ? { id: _coord.id, firstname: _coord.firstname, lastname: _coord.lastname, profilepicture: _coord.profilepicture || "", role: _coord.role }
      : null;
    const _txCoordId = _agentUser?.transactionCoordinatorId;
    const _txCoord = _txCoordId ? (users || []).find((u) => u.id === _txCoordId) : null;
    const transactionCoordinator = _txCoord
      ? { id: _txCoord.id, firstname: _txCoord.firstname, lastname: _txCoord.lastname, profilepicture: _txCoord.profilepicture || "", role: _txCoord.role }
      : null;

    allowedStages.forEach((stage) => {
      // 👉 agar already exist karta hai → skip
      if (existingTracker[stage]) return;

      const stageTasks = expandStageItems(tasks?.[stage] || [], stage, { coordinator, transactionCoordinator });

      newTasks = [
        ...newTasks,
        ...stageTasks.map((t) => ({
          ...t,
          stage: stage,
          status: stage === selectedStage ? "Open" : "Completed",
          createdAt: new Date().toISOString(),
        })),
      ];

      // 👉 mark as added
      updatedTracker[stage] = true;
    });

    const finalTasks = [...existingTasks, ...newTasks];

    // -----------------------------
    // 🔥 2. Detect if new images are selected
    // -----------------------------
    let isNewImages =
      incomingFiles &&
      incomingFiles.length > 0 &&
      typeof incomingFiles[0] !== "string"; // if File type → new upload

    if (isNewImages) {
      // -----------------------------
      // 🔥 3. Upload Newly Selected Images
      // -----------------------------
      finalImageUrls = await uploadImagesToFirebase(incomingFiles);

      // -----------------------------
      // 🔥 4. Delete Old Firebase Images
      // -----------------------------
      for (let url of oldImages) {
        try {
          const fileRef = ref(storage, url);
          await deleteObject(fileRef);
        } catch (err) {
          console.log("Old image delete error:", err);
        }
      }
    } else {
      // -----------------------------
      // 🔥 5. Images NOT changed → keep old URLs as is
      // -----------------------------
      finalImageUrls = incomingFiles; // existing Firebase URLs
    }

    const wasApproved = editdata?.status === "Approved";
    // Client Care (Supervisor) can complete any pending deal.
    // Admin can approve sale turn-ins but should not "complete" file requests
    // (those are Client Care's responsibility).
    const isSaleTurnIn = editdata?.requestType === "saleTurnIn";
    const canFlipStatus =
      user.role === "Supervisor" ||
      (user.role === "Admin" && isSaleTurnIn);

    let newdata = {
      status: canFlipStatus ? "Approved" : editdata.status,
      approvedby: user.id,
      dealtype: data.step2.clientType,
      propertyphoto: finalImageUrls,
      customers: data.step2.clientinfo,
      dealStage: data.step1.dealStage,
      financingType: data.step1.financingType,
      earnestMoney: data.step1.earnestMoney,
      inspection: data.step1.inspection,
      inspectionDeadline: data.step1.inspectionDeadline,
      financingDeadline: data.step1.financingDeadline,
      // mlsNumber: data.step1.mlsNumber,
      offerPrice: data.step1.offerPrice,
      propertyType: data.step1.propertyType,
      agentCommission: data.step3.agentCommission,
      fixedagentcommission: data.step3.fixedagentcommission,
      agentData: data.step3.agentid,
      agentName: data.step3.agentName,
      brokeradminfee: data.step3.brokeradminfee,
      captype: data.step3.captype,
      captypedescription: data.step3.captypedescription,
      closingdate: data.step1.closingdate,
      leadCommission: data.step3.leadCommission,
      leadsource: data.step3.leadsource,
      propertyaddress: data.step1.propertyaddress,
      splitdescription: data.step3.splitdescription,
      splittype: data.step3.splittype,
      inhousereferral: data.step3?.inhousereferral || false,

      teamleadName: data.step3.teamleadName,
      propertyLocation: data.step1.propertyLocation,
      flatfee: data.step4.flatfee,
      flatfeeamount: data.step4.flatfeeamount,
      assignedteamlead: data.step3.assignedteamlead,
      thirdpartyagentCommission: data.step3.thirdpartyagentCommission,
      thirdpartyagentName: data.step3.thirdpartyagentName,
      agentCommissionamount: data.step4.agentCommissionamount,
      bankcommission: data.step4.bankcommission,
      buyersidecommissionrate: data.step4.buyersidecommissionrate,
      leadsourceCommissionamount: data.step4.leadsourceCommissionamount,
      sellersidecommissionrate: data.step4.sellersidecommissionrate,
      takehomecommissionamount: data.step4.takehomecommissionamount,
      teamleadCommissionamount: data.step4.teamleadCommissionamount,
      teamleaddiscount: data.step4.teamleaddiscount,
      agentdiscount: data.step4.agentdiscount,
      teamleadcommissionrate: data.step4.teamleadcommissionrate,
      thirdpartyagentcommissionamount:
        data.step4.thirdpartyagentcommissionamount,
      totalCommissionamount: data.step4.totalCommissionamount,
      totalcommissionrate: data.step4.totalcommissionrate,
      tasks: finalTasks,
      taskStatusTracker: updatedTracker,
    };

    try {
      let result = await updateItem("deals", id, newdata);

      if (result === "success") {
        if (newTasks.length > 0) {
          newTasks.forEach((task) => {
            if (task?.assignee) {
              newmessagesuccess(
                "New Task Assigned",
                task.assignee?.id,
                task?.title || "",
                task.id || "",
                "newtask",
                newdata.createdat,
              );
            }
          });
        }
        toast.success("Deal updated successfully!");
        const updatedDeals = deals.map((item) =>
          item.createdat === id ? { ...item, ...newdata } : item,
        );

        console.log(updatedDeals);
        fetchDeal();
        dispatch({
          type: actionType.STORE_DEALS,
          deals: updatedDeals,
        });
        setIsOpen(false);
        if (!wasApproved && newdata.status === "Approved") {
          const completedDeal = { ...editdata, ...newdata, createdat: id };
          if (completedDeal.requestType === "saleTurnIn") {
            try {
              await notifyAccountantsOnApproval(completedDeal, users, user);
            } catch (notifyErr) {
              console.error("Failed to notify accountants:", notifyErr);
            }
          } else {
            try {
              await notifyAgentOnFileComplete(completedDeal, users, user);
            } catch (notifyErr) {
              console.error("Failed to notify requesting agent:", notifyErr);
            }
            try {
              const emailResult = await emailAgentOnFileComplete(
                completedDeal,
                users,
                user,
              );
              if (!emailResult?.ok) {
                if (emailResult?.reason === "no-gmail") {
                  toast.info(
                    "File completed. Connect Gmail in Settings to email the agent automatically.",
                  );
                } else if (emailResult?.reason === "no-recipient") {
                  toast.info(
                    "File completed. No agent email on file, so no email was sent.",
                  );
                } else {
                  toast.error(
                    "File completed, but the agent email failed to send.",
                  );
                }
              }
            } catch (emailErr) {
              console.error("Failed to email agent on file complete:", emailErr);
            }
          }
        }
      } else {
        toast.error(result || "Failed to update deal");
      }
    } catch (err) {
      toast.error(err.message);
    } finally {
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      const data = await getTaskTemplate();
      setTasks(data || {});
      console.log("task templates", data);
    };

    fetchData();
  }, []);

  if (!deal) return <div className="p-10 text-center">Loading...</div>;

  return (
    <div className="">
      <PageHeader title="Deal Details" />
      <div className="px-[25px] mt-3">
        <BreadCrumbs
          crumb1={`${isPage === 'deal-board' ? 'Deal Board' : 'Transactions'}`}
          crumb2="Transactions Detail"
          crumbLink1={`${isPage === 'deal-board' ? '/dashboard/deal-board' : '/dashboard/deals'}`}
        />
      </div>

      {/* Main Layout */}
      <div className="flex flex-wrap lg:justify-between w-[96%] mx-auto my-8">
        {/* LEFT SECTION */}
        <div className={activeTab === "emails" ? "w-full" : "w-full lg:w-[59%]"}>
          <div className="flex gap-x-2 px-6 border-b border-b-white/6 bg-white rounded-xl mb-4 overflow-x-scroll">
            {tabs.map((tab) => (
              <button
                key={tab}
                onClick={() => setActiveTab(tab)}
                className={`py-3 px-4 text-base font-semibold cursor-pointer border-b-[3px] transition-all ${
                  activeTab === tab
                    ? "text-slate-900 border-b-slate-900"
                    : "text-slate-400 border-b-transparent"
                }`}
              >
                {tab === "documents"
                  ? "📁 Documents"
                  : tab === "task"
                    ? "📋 Task"
                    : tab === "chat"
                      ? "💬 Chat"
                      : tab === "openHouses"
                        ? "🏠 Open Houses"
                        : tab === "emails"
                          ? "✉️ Emails"
                          : "📊 Overview"}
              </button>
            ))}
          </div>
          {activeTab === "overview" && (
            <div className="lg:col-span-2 space-y-6">
              {/* Property Image */}
              <PropertyImage deal={deal} />
              {user.role != "Accountant" && <StickyNote deal={deal} />}

              {/* Deal Summary is now embedded inside ListingDetail for
                  both seller and buyer deals (see ListingDetail). The
                  standalone card above is gone — one combined card per
                  deal, with Important Dates + static fields at the top
                  of the listing/buy details. */}
              <ListingDetail
                deal={deal}
                onSubmit={() => handleDeal()}
                updatedealstage={(item) => updatedealstage(item)}
              />

              {/* Location */}
              <DealLocation deal={deal} />
            </div>
          )}
          {activeTab === "documents" && <DocumentsTab deal={deal} />}
          {activeTab === "task" && <Task deal={deal} taskId={taskId} />}
          {activeTab === "openHouses" && <DealOpenHousesTab deal={deal} />}
          {activeTab === "emails" && (
            <EmailCenterTab deal={deal} onDealUpdate={(next) => setDeal(next)} />
          )}
          {activeTab === "chat" && <Chat data={deal} />}
        </div>

        {/* RIGHT SECTION */}
        <div
          className={`space-y-4 w-full lg:w-[39%] mt-5 lg:mt-0 ${
            activeTab === "emails" ? "hidden" : ""
          }`}
        >
          {/* Commissions Breakdown */}
          {deal.status === "Approved" && <ComissionBreakDown deal={deal} />}

          {/* People Section */}
          <PeopleInvolve deal={deal} getAgent={(deal) => getAgent(deal)} />

          {/* Client Information */}
          <ClientInform
            deal={deal}
            onCustomersChange={(nextCustomers) =>
              setDeal((d) => (d ? { ...d, customers: nextCustomers } : d))
            }
          />

          {/* Client Portal (magic-link Utility Info Sheet) */}
          {user.role != "Accountant" && (
            <ClientPortalPanel
              deal={deal}
              onPortalChange={(nextPortal) =>
                setDeal((d) => (d ? { ...d, clientPortal: nextPortal } : d))
              }
            />
          )}
          <button
            onClick={() => {
              handleOnEdit(deal);
            }}
            className="px-4 py-3  rounded-lg text-md bg-[#1E293B] text-white text-[15px] transition w-full"
          >
            Edit Deal
          </button>

          {(user.role === "Admin" ||
            (user.role === "Supervisor" && user.access?.deleteDeal)) && (
            <button
              onClick={() => {
                handleDelete(deal);
              }}
              className="px-4 py-3  rounded-lg text-md bg-red-600 text-white text-[15px] transition w-full"
            >
              Delete Deal
            </button>
          )}
        </div>
      </div>
      {isOpen && (
        <AddNewDeal
          onClose={() => setIsOpen(false)}
          isedit={true}
          editdata={editdata}
          onSubmit={(data, bool, id) => {
            updatedeal(data, bool, id);
          }}
          steps={steps}
        />
      )}

      {isDelete && (
        <DeleteDeal
          deal={editdata}
          onClose={() => setIsDelete(false)}
          onSubmit={() => {
            navigate(-1);
          }}
        />
      )}
    </div>
  );
}

export default MainDetail;
